// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-logo-card-page',
    templateUrl: './logo-card-page.component.html',
    styleUrls: ['./logo-card-page.component.scss'],
    standalone: false
})
export class LogoCardPageComponent implements OnInit {
  @Input() style: {} = {};
  @Input() downloadStyle: {} = {};

  constructor() { }

  ngOnInit(): void {
  }

}
